(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const init = scope => {
  scope.querySelectorAll('.fti-moments').forEach(root => {
   if(root.dataset.v4Ready) return; root.dataset.v4Ready='true';
   const rail=root.querySelector('.fti-moments__rail');
   root.querySelectorAll('[data-gallery-move]').forEach(button=>button.addEventListener('click',()=>{
    const width=rail.querySelector('figure')?.getBoundingClientRect().width || 350;
    rail.scrollBy({left:Number(button.dataset.galleryMove)*(width+24),behavior:reduced.matches?'auto':'smooth'});
   }));
  });
  scope.querySelectorAll('.fti-destinations').forEach(root=>{
   root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{
    root.querySelectorAll('[data-filter]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
   }));
  });
  if(reduced.matches || !('IntersectionObserver' in window)) return;
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
   if(entry.isIntersecting){entry.target.classList.add('fti-v4-motion');observer.unobserve(entry.target);}
  }),{threshold:.12});
  scope.querySelectorAll('.fti-locals__featured,.fti-locals__culture-card,.fti-locals__story-grid a,.fti-cinema__philosophy,.fti-cinema__collection,.fti-story__highlights article,.fti-v4-highlights article,.fti-v4-travel-notes,.fti-v4-related-head').forEach(el=>observer.observe(el));
 };
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();
